export const MODULE_RISK_ZONES = "risk_zones"
export const MODULE_SPEEDINGS = "speedings"
export const MODULES_SAFETY = [MODULE_RISK_ZONES, MODULE_SPEEDINGS]
export const API_MODULE_RISK_ZONE = "RISK_ZONE"
export const API_MODULE_SPEEDINGS = "SPEED_LIMIT"